import {
  BaseCellRenderer,
  createFromBaseCellRenderer,
  createIcon,
} from '@blocksuite/data-view';
import { css } from '@emotion/css';
import { baseTheme } from '@streamlain/theme';
import { format } from 'date-fns/format';
import { html } from 'lit';

import { updatedTimePropertyModelConfig } from './define.js';

const updatedTimeCellStyle = css({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  padding: '0',
  border: 'none',
  fontFamily: baseTheme.fontSansFamily,
  color: 'var(--streamlain-text-primary-color)',
  fontWeight: '400',
  backgroundColor: 'transparent',
  fontSize: 'var(--data-view-cell-text-size)',
  lineHeight: 'var(--data-view-cell-text-line-height)',
  height: 'var(--data-view-cell-text-line-height)',
});

export class UpdatedTimeCell extends BaseCellRenderer<number, number> {
  override beforeEnterEditMode() {
    return false;
  }

  override render() {
    const value = this.value ? format(this.value, 'yyyy/MM/dd HH:mm') : '';
    return html`<div class="${updatedTimeCellStyle}">${value}</div>`;
  }
}

export const updatedTimeColumnConfig =
  updatedTimePropertyModelConfig.createPropertyMeta({
    icon: createIcon('DateTimeIcon'),
    cellRenderer: {
      view: createFromBaseCellRenderer(UpdatedTimeCell),
    },
  });
